import { syncServerTimeOffset } from "./serverTimeHelpers";

const CACHE_KEY = "visitor_profile_cache";
const CACHE_TTL_MS = 5 * 60 * 1000;

let memoryProfile = null;
let inflightProfileRequest = null;

const persistProfileCache = (profile) => {
  if (!profile || typeof window === "undefined") {
    return;
  }

  try {
    sessionStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        data: profile,
        expires: Date.now() + CACHE_TTL_MS,
      })
    );
  } catch (_) {
    // ignore quota errors
  }
};

const readProfileCache = () => {
  if (memoryProfile) {
    return memoryProfile;
  }

  if (typeof window === "undefined") {
    return null;
  }

  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (!cached) {
      return null;
    }

    const parsed = JSON.parse(cached);
    if (!parsed?.data || parsed.expires <= Date.now()) {
      sessionStorage.removeItem(CACHE_KEY);
      return null;
    }

    memoryProfile = parsed.data;
    return memoryProfile;
  } catch (_) {
    return null;
  }
};

export const primeVisitorProfileCache = (profile) => {
  if (!profile) {
    return;
  }

  memoryProfile = profile;
  if (profile.currency) {
    localStorage.setItem("currency", profile.currency);
  }
  persistProfileCache(profile);
};

export const fetchVisitorProfile = async (axios, baseUrl, options = {}) => {
  const force = options.force === true;

  if (!force) {
    const cached = readProfileCache();
    if (cached) {
      if (cached.currency) {
        localStorage.setItem("currency", cached.currency);
      }
      return cached;
    }
  }

  if (!force && inflightProfileRequest) {
    return inflightProfileRequest;
  }

  inflightProfileRequest = axios
    .get(`${baseUrl}/profile`)
    .then(async (response) => {
      const profile = response?.data?.data ?? null;
      memoryProfile = profile;

      if (profile?.currency) {
        localStorage.setItem("currency", profile.currency);
      }

      if (!options.skipServerTimeSync) {
        await syncServerTimeOffset().catch(() => 0);
      }

      persistProfileCache(profile);
      return profile;
    })
    .finally(() => {
      inflightProfileRequest = null;
    });

  return inflightProfileRequest;
};

/** @deprecated use fetchVisitorProfile */
export const fetchAndCacheProfile = fetchVisitorProfile;
